import { Link } from 'react-router-dom'
import { useCartStore, selectTotalItems, selectTotalPrice } from '@store/useCartStore'
import './CartPage.scss'

const FREE_SHIPPING_THRESHOLD = 150
const SHIPPING_COST = 15

export default function CartPage() {
  const items = useCartStore((s) => s.items)
  const removeItem = useCartStore((s) => s.removeItem)
  const updateQty = useCartStore((s) => s.updateQty)
  const totalItems = useCartStore(selectTotalItems)
  const subtotal = useCartStore(selectTotalPrice)
  const shipping = subtotal >= FREE_SHIPPING_THRESHOLD ? 0 : SHIPPING_COST
  const total = Math.round((subtotal + shipping) * 100) / 100

  if (items.length === 0) {
    return (
      <div className="cart-page">
        <div className="cart-page-empty">
          <h1 className="cart-page-title">Coșul tău</h1>
          <p>Nu ai niciun produs în coș.</p>
          <Link to="/shop" className="btn-primary">Descoperă produsele</Link>
        </div>
      </div>
    )
  }

  return (
    <div className="cart-page">
      <h1 className="cart-page-title">Coșul tău</h1>
      <p className="cart-page-count">{totalItems} {totalItems === 1 ? 'produs' : 'produse'}</p>

      <div className="cart-page-layout">
        <div className="cart-page-items">
          <div className="cart-table-head">
            <span className="cart-col-product">Produs</span>
            <span className="cart-col-price">Preț</span>
            <span className="cart-col-qty">Cantitate</span>
            <span className="cart-col-total">Total</span>
            <span className="cart-col-remove" />
          </div>

          {items.map((item) => {
            const key = `${item.productId}-${item.variantName ?? 'default'}`
            const lineTotal = Math.round(item.unitPrice * item.quantity * 100) / 100
            return (
              <div key={key} className="cart-row">
                <div className="cart-col-product">
                  <Link to={`/product/${item.productSlug}`} className="cart-row-link">
                    {item.productImage ? (
                      <img src={item.productImage} alt={item.productName} className="cart-row-img" />
                    ) : (
                      <div className="cart-row-img-placeholder" />
                    )}
                    <div className="cart-row-details">
                      <span className="cart-row-name">{item.productName}</span>
                      {item.variantName && (
                        <span className="cart-row-variant">{item.variantName}</span>
                      )}
                    </div>
                  </Link>
                </div>
                <div className="cart-col-price">{item.unitPrice} lei</div>
                <div className="cart-col-qty">
                  <div className="cart-qty">
                    <button
                      type="button"
                      onClick={() => updateQty(item.productId, item.variantName, item.quantity - 1)}
                      aria-label="Scade"
                    >
                      −
                    </button>
                    <span>{item.quantity}</span>
                    <button
                      type="button"
                      onClick={() => updateQty(item.productId, item.variantName, item.quantity + 1)}
                      aria-label="Crește"
                    >
                      +
                    </button>
                  </div>
                </div>
                <div className="cart-col-total">{lineTotal} lei</div>
                <div className="cart-col-remove">
                  <button
                    type="button"
                    className="cart-remove-btn"
                    onClick={() => removeItem(item.productId, item.variantName)}
                    aria-label="Elimină"
                  >
                    ✕
                  </button>
                </div>
              </div>
            )
          })}
        </div>

        <aside className="cart-page-summary">
          <h2 className="cart-summary-title">Sumar comandă</h2>
          <div className="cart-summary-row">
            <span>Subtotal</span>
            <span>{Math.round(subtotal * 100) / 100} lei</span>
          </div>
          <div className="cart-summary-row">
            <span>Livrare</span>
            <span>{shipping === 0 ? 'Gratuită' : `${shipping} lei`}</span>
          </div>
          {shipping > 0 && (
            <p className="cart-summary-hint">
              Livrare gratuită pentru comenzi de peste {FREE_SHIPPING_THRESHOLD} lei
            </p>
          )}
          <div className="cart-summary-divider" />
          <div className="cart-summary-row cart-summary-total">
            <span>Total</span>
            <span>{total} lei</span>
          </div>
          <Link to="/checkout" className="btn-primary cart-summary-btn">
            Finalizează comanda
          </Link>
          <Link to="/shop" className="cart-summary-continue">
            ← Continuă cumpărăturile
          </Link>
        </aside>
      </div>
    </div>
  )
}
